import { TPAComponentProps } from '../../types';

export enum RibbonShape {
  Rectangle = 'rectangle',
  Square = 'square',
}

export interface RibbonProps extends TPAComponentProps {
  shape?: RibbonShape;
  children?: React.ReactNode;
}
